import React from "react";

export default function BlockButton({ label, onClick, icon: Icon }) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-2.5 px-3 py-2 text-left rounded-lg text-sm border border-bookish-purple/10 bg-white hover:bg-bookish-purple/5 hover:border-bookish-purple/25 transition-all group"
      type="button"
    >
      {Icon && (
        <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-md bg-bookish-purple/8 text-bookish-purple/70 group-hover:bg-bookish-purple/15 group-hover:text-bookish-purple transition-colors">
          <Icon size={15} />
        </span>
      )}
      <span className="font-medium text-bookish-purple/80 group-hover:text-bookish-purple">{label}</span>
    </button>
  );
}
